exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@page {\n  .UCSFBulkReportLauncher {\n    size: letter;\n  }\n}\n@media print {\n  .UCSFBulkReportLauncher {\n    width: 9.5in;\n    /* page-break-after works, as well */\n  }\n  .UCSFBulkReportLauncher .pagebreak {\n    page-break-after: always;\n    break-after: always;\n  }\n}", ""]);

